import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 解决 ResizeObserver loop completed with undelivered notifications 错误
const resizeObserverErrorHandler = (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation()
    e.preventDefault()
    return false
  }
}

// 多种方式拦截错误
window.addEventListener('error', resizeObserverErrorHandler, true)
window.addEventListener('unhandledrejection', resizeObserverErrorHandler, true)

// 重写 console.error 过滤掉 ResizeObserver 错误
const originalConsoleError = console.error
console.error = function(...args) {
  const message = args[0]
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return
  }
  originalConsoleError.apply(console, args)
}

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
